import { createSlice } from "@reduxjs/toolkit";
import { getInformationList, getInformationDetail, saveInformation, deleteInformation } from "../controller/information.controller";
import { Information } from "../types/informationType";
import { SaveResponse } from "../types/common";

interface InformationState {
  loading: boolean;
  list: Information[];
  total: { pages: number; data: number };
  detail: Information | null;
  detailLoading: boolean;
  response: SaveResponse | null;
  error: string | null;
}

const initialState: InformationState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  detail: null,
  detailLoading: false,
  response: null,
  error: null,
};

const informationSlice = createSlice({
  name: "information",
  initialState,
  reducers: {
    resetInformationResponse: (state) => {
      state.response = null;
    },
    resetInformationDetail: (state) => {
      state.detail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInformationList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInformationList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getInformationList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data informasi";
      })
      .addCase(getInformationDetail.pending, (state) => {
        state.detailLoading = true;
        state.detail = null;
      })
      .addCase(getInformationDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.detail = action.payload.data ?? null;
      })
      .addCase(getInformationDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.error = action.error.message ?? "Gagal memuat detail informasi";
      })
      .addCase(saveInformation.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveInformation.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveInformation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan informasi";
      })
      .addCase(deleteInformation.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetInformationResponse, resetInformationDetail } = informationSlice.actions;
export default informationSlice.reducer;
